import { module } from 'angular';
import WfAffectListComponent from './wf-affect-list/wf-affect-list.component';
import WfEditorComponent from './wf-editor/wf-editor.component';
import WfEditorHomeComponent from './wf-editor-home/wf-editor-home.component';
import WfFormActionsComponent from './wf-form-actions/wf-form-actions.component';
import wfFormActionsRun from './wf-form-actions/wf-form-actions.run';
import WfIconComponent from './wf-icon/wf-icon.component';
import WfNodeEditorComponent from './wf-node-editor/wf-node-editor.component';
import WfNodeSelectComponent from './wf-node-select/wf-node-select.component';
import WfStateTodoComponent from './wf-state-todo/wf-state-todo.component';
import WfObservationsComponent from './wf-observations/wf-observations.component';

export default module('app')
	.component('wfAffectList', WfAffectListComponent)
	.component('wfEditor', WfEditorComponent)
	.component('wfEditorHome', WfEditorHomeComponent)
	.component('wfFormActions', WfFormActionsComponent)
	.component('wfIcon', WfIconComponent)
	.component('wfNodeEditor', WfNodeEditorComponent)
	.component('wfNodeSelect', WfNodeSelectComponent)
	.component('wfObservations', WfObservationsComponent)
	.component('wfStateTodo', WfStateTodoComponent)
	.run(wfFormActionsRun)
	.name;
